// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__FJ8WI","title":"BackImages_title__IrBF7","images":"BackImages_images__3suiq"};